import React, { useState } from 'react';

const RapportsModule = () => {
  const [activeTab, setActiveTab] = useState('catalogue');

  const HISTORIQUE = [
    { type: 'Rapport Mensuel DG', periode: 'Mai 2026', date: '01/06/2026', par: 'Auto', pages: 2 },
    { type: 'Rapport RH', periode: 'Semaine 21', date: '25/05/2026', par: 'Karmelle H.', pages: 2 },
    { type: 'Rapport Projets', periode: 'Mai 2026', date: '31/05/2026', par: 'Auto', pages: 3 },
    { type: 'Rapport Financier', periode: 'Mai 2026', date: '01/06/2026', par: 'Marie B.', pages: 3 },
    { type: 'Rapport EMPLOI+', periode: 'Mai 2026', date: '01/06/2026', par: 'Auto', pages: 2 }
  ];

  const rapports = [
    {
      id: 'mensuel',
      icon: '📈',
      nom: 'Rapport Mensuel DG',
      desc: 'Synthèse complète : CA, projets, RH, alertes, décisions. Rapport de pilotage pour la Direction Générale.',
      meta: '⚡ Génération automatique · ~2 pages',
      color: 'rgba(201,168,76,.15)'
    },
    {
      id: 'financier',
      icon: '💰',
      nom: 'Rapport Financier',
      desc: 'CA par filiale, charges, résultat, trésorerie, factures en attente, TVA.',
      meta: '📊 Données comptabilité · ~3 pages',
      color: 'rgba(67,160,71,.15)'
    },
    {
      id: 'rh',
      icon: '👥',
      nom: 'Rapport RH & Performance',
      desc: 'Scores employés, présence, retards, accomplissement tâches, objectifs.',
      meta: '👤 8 employés · ~2 pages',
      color: 'rgba(25,118,210,.15)'
    },
    {
      id: 'projets',
      icon: '📋',
      nom: 'Rapport Projets',
      desc: 'Avancement portefeuille, jalons, budget consommé, risques, retards.',
      meta: '📁 5 projets actifs · ~2 pages',
      color: 'rgba(171,71,188,.15)'
    },
    {
      id: 'emploi',
      icon: '💼',
      nom: 'Rapport EMPLOI+ / StagesBénin',
      desc: 'Placements, candidats, offres, taux d\'insertion, entreprises partenaires.',
      meta: '🎯 Mensuel · ~2 pages',
      color: 'rgba(0,105,92,.15)'
    },
    {
      id: 'formation',
      icon: '📚',
      nom: 'Rapport FHC Formation',
      desc: 'Apprenants, programmes, taux de complétion, satisfaction, revenus formation.',
      meta: '🎓 15 apprenants · ~2 pages',
      color: 'rgba(251,140,0,.15)'
    }
  ];

  const genRapport = (type) => {
    alert(`⚡ Génération du rapport ${type} en cours...`);
  };

  return (
    <div style={{ background: '#080e1a', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif', fontSize: 13, color: '#fff', padding: '20px 24px 40px' }}>
      {/* HEADER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 24, fontWeight: 600 }}>📊 Rapports & Exports</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.42)', marginTop: 3 }}>Rapports automatiques · Direction Générale</div>
        </div>
        <div style={{ display: 'flex', gap: 9 }}>
          <div style={{
            fontSize: 10,
            color: '#445',
            background: '#111f2e',
            padding: '4px 11px',
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.06)'
          }}>
            {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </div>
          <button
            onClick={() => genRapport('mensuel')}
            style={{
              background: 'rgba(201,168,76,0.12)',
              border: '1px solid rgba(201,168,76,0.3)',
              borderRadius: 6,
              padding: '5px 13px',
              color: '#C9A84C',
              fontSize: 11,
              cursor: 'pointer'
            }}
          >
            ⚡ Générer rapport mensuel
          </button>
        </div>
      </div>

      {/* TABS */}
      <div style={{ display: 'flex', gap: 2, borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 20 }}>
        {[
          { id: 'catalogue', label: '📋 Catalogue des rapports' },
          { id: 'preview', label: '👁️ Prévisualisation' },
          { id: 'planification', label: '📅 Planification auto' },
          { id: 'historique', label: '📂 Historique' }
        ].map(tab => (
          <div
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '11px 16px',
              fontSize: 12,
              color: activeTab === tab.id ? '#C9A84C' : '#667',
              cursor: 'pointer',
              borderBottom: activeTab === tab.id ? '2px solid #C9A84C' : '2px solid transparent',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap'
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* CATALOGUE */}
      {activeTab === 'catalogue' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
            {rapports.map(r => (
              <div
                key={r.id}
                onClick={() => genRapport(r.id)}
                style={{
                  background: '#111f2e',
                  border: '1px solid rgba(255,255,255,0.06)',
                  borderRadius: 12,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = 'rgba(201,168,76,0.3)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ padding: 20, display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                  <div style={{
                    width: 48,
                    height: 48,
                    borderRadius: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 22,
                    flexShrink: 0,
                    background: r.color
                  }}>
                    {r.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{r.nom}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.42)', lineHeight: 1.4 }}>{r.desc}</div>
                  </div>
                </div>
                <div style={{
                  padding: '12px 20px',
                  background: 'rgba(255,255,255,0.02)',
                  borderTop: '1px solid rgba(255,255,255,0.06)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                  <span style={{ fontSize: 10, color: '#556' }}>{r.meta}</span>
                  <span style={{ fontSize: 10, color: '#C9A84C', fontWeight: 600 }}>Générer →</span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 11, padding: '16px 18px' }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#fff', marginBottom: 14 }}>📂 Derniers rapports générés</div>
            {HISTORIQUE.slice(0, 4).map((r, i) => (
              <div key={i} style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '9px 0',
                borderBottom: i < 3 ? '1px solid rgba(255,255,255,0.04)' : 'none'
              }}>
                <span style={{ fontSize: 16 }}>📄</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 500, color: '#fff' }}>{r.type} — {r.periode}</div>
                  <div style={{ fontSize: 9, color: '#556', marginTop: 2 }}>
                    Généré le {r.date} par {r.par} · {r.pages} pages
                  </div>
                </div>
                <button
                  onClick={() => genRapport(r.type.toLowerCase().includes('mensuel') ? 'mensuel' : 'financier')}
                  style={{
                    fontSize: 10,
                    padding: '4px 10px',
                    background: 'transparent',
                    border: '1.5px solid rgba(255,255,255,0.06)',
                    borderRadius: 7,
                    color: '#888',
                    cursor: 'pointer'
                  }}
                >
                  Regénérer
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* HISTORIQUE */}
      {activeTab === 'historique' && (
        <div>
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600 }}>📂 Historique des rapports</div>
          </div>

          <div style={{ background: '#111f2e', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 11, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Rapport</th>
                  <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Période</th>
                  <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Généré le</th>
                  <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Par</th>
                  <th style={{ fontSize: 9, color: '#445', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', padding: '9px 11px', borderBottom: '1px solid rgba(255,255,255,0.06)', textAlign: 'left' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {HISTORIQUE.map((r, i) => (
                  <tr key={i}>
                    <td style={{ fontSize: 11, color: '#fff', fontWeight: 500, padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                      {r.type}
                    </td>
                    <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>{r.periode}</td>
                    <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>{r.date}</td>
                    <td style={{ fontSize: 11, color: '#aaa', padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>{r.par}</td>
                    <td style={{ padding: '10px 11px', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                      <button style={{
                        fontSize: 9,
                        padding: '3px 9px',
                        background: 'transparent',
                        border: '1.5px solid rgba(255,255,255,0.06)',
                        borderRadius: 7,
                        color: '#888',
                        cursor: 'pointer'
                      }}>
                        📥 PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Other tabs - Placeholder */}
      {(activeTab === 'preview' || activeTab === 'planification') && (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>
            {activeTab === 'preview' ? '👁️' : '📅'}
          </div>
          <div style={{ fontSize: 16, color: '#C9A84C', marginBottom: 8 }}>
            {activeTab === 'preview' ? 'Prévisualisation' : 'Planification Automatique'}
          </div>
          <div style={{ fontSize: 13, color: '#667' }}>
            Fonctionnalité à venir
          </div>
        </div>
      )}
    </div>
  );
};

export default RapportsModule;
